/* global HOME_LOADER_MINIMUM_DURATION */

import { Controller } from 'stimulus';
import config from '../config';

const { movementThresholdBeforeShowingInterface } = config;

class HomeController extends Controller {
  connect() {
    this.layoutController = this.application.getControllerForElementAndIdentifier(document.body, 'layout');

    this.layoutController.hideNavigationComponents();

    // We've to wait for the loader to be hidden.
    this.showInterfaceEnabled = false;

    this.hasShownInterface = false;

    this.mouseMoveDelta = 0;

    setTimeout(() => {
      this.showInterfaceEnabled = true;
    }, HOME_LOADER_MINIMUM_DURATION * 1000);
  }

  onMouseMove(event) {
    if (!this.showInterfaceEnabled) {
      return;
    }

    this.mouseMoveDelta += Math.abs(event.movementX) + Math.abs(event.movementY);

    if (this.mouseMoveDelta >= movementThresholdBeforeShowingInterface) {
      this.showInterface();
    }
  }

  onTouchStart() {
    if (!this.showInterfaceEnabled) {
      return;
    }

    this.showInterface();
  }

  onMouseDown() {
    if (!this.showInterfaceEnabled) {
      return;
    }

    this.showInterface();
  }

  showInterface() {
    if (this.hasShownInterface) {
      return;
    }

    document.body.classList.remove('hide-interface');

    this.hasShownInterface = true;

    this.layoutController.isHeaderVisible = true;
    this.layoutController.areHeaderElementsVisible = true;
    this.layoutController.toggleHeader();
  }
}

export default HomeController;
